
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Çerez Politikası
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Web sitemizde kullanılan çerezler hakkında detaylı bilgilendirme
            </p>
          </div>
        </div>
      </section>

      {/* İçerik */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card>
            <div className="prose prose-lg max-w-none">
              <div className="space-y-8 text-[15px] text-gray-700 leading-relaxed">
                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">1. Çerez Nedir?</h2>
                  <p>
                    Çerezler, bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet, telefon) 
                    kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin düzgün çalışmasını sağlamak, 
                    kullanıcı deneyimini iyileştirmek ve site performansını analiz etmek için kullanılır.
                  </p>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">2. Çerez Türleri</h2>
                  
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-3">Zorunlu Çerezler</h3>
                  <p>
                    Bu çerezler web sitesinin temel işlevlerini yerine getirmesi için gereklidir. 
                    Bu çerezler olmadan web sitesi düzgün çalışamaz.
                  </p>
                  
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-3 mt-6">Performans Çerezleri</h3>
                  <p>
                    Bu çerezler, web sitesinin nasıl kullanıldığına dair bilgi toplar. 
                    Hangi sayfaların ziyaret edildiği, ne kadar süre geçirildiği gibi istatistiksel veriler sağlar.
                  </p>
                  
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-3 mt-6">İşlevsellik Çerezleri</h3>
                  <p>
                    Bu çerezler, web sitesinin gelişmiş özelliklerini ve kişiselleştirme seçeneklerini sağlar. 
                    Dil tercihleri, bölge ayarları gibi bilgileri hatırlar.
                  </p>
                  
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-3 mt-6">Hedefleme Çerezleri</h3>
                  <p>
                    Bu çerezler, size ve ilgi alanlarınıza daha uygun reklamlar göstermek için kullanılır. 
                    Ayrıca aynı reklamın tekrar tekrar gösterilmesini engeller.
                  </p>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">3. Kullandığımız Çerezler</h2>
                  
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300 text-[14px]">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="border border-gray-300 px-4 py-2 text-left">Çerez Adı</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Türü</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Amacı</th>
                          <th className="border border-gray-300 px-4 py-2 text-left">Süresi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">session_id</td>
                          <td className="border border-gray-300 px-4 py-2">Zorunlu</td>
                          <td className="border border-gray-300 px-4 py-2">Oturum yönetimi</td>
                          <td className="border border-gray-300 px-4 py-2">Oturum süresi</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">language_pref</td>
                          <td className="border border-gray-300 px-4 py-2">İşlevsellik</td>
                          <td className="border border-gray-300 px-4 py-2">Dil tercihi</td>
                          <td className="border border-gray-300 px-4 py-2">1 yıl</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">analytics_id</td>
                          <td className="border border-gray-300 px-4 py-2">Performans</td>
                          <td className="border border-gray-300 px-4 py-2">Site analizi</td>
                          <td className="border border-gray-300 px-4 py-2">2 yıl</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">marketing_consent</td>
                          <td className="border border-gray-300 px-4 py-2">Hedefleme</td>
                          <td className="border border-gray-300 px-4 py-2">Pazarlama onayı</td>
                          <td className="border border-gray-300 px-4 py-2">6 ay</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">4. Üçüncü Taraf Çerezleri</h2>
                  <p>Web sitemizde aşağıdaki üçüncü taraf hizmetlerin çerezleri kullanılabilir:</p>
                  <ul className="list-disc list-inside space-y-2 mt-3">
                    <li><strong>Google Analytics:</strong> Site trafiği ve kullanıcı davranışı analizi</li>
                    <li><strong>Google Maps:</strong> Harita ve konum hizmetleri</li>
                    <li><strong>Facebook Pixel:</strong> Sosyal medya entegrasyonu ve reklamcılık</li>
                    <li><strong>YouTube:</strong> Video içerik gösterimi</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">5. Çerez Yönetimi</h2>
                  <p>
                    Çerezleri kontrol etmek ve yönetmek için tarayıcınızın ayarlarını kullanabilirsiniz. 
                    Çoğu tarayıcı çerezleri otomatik olarak kabul eder, ancak isterseniz bu ayarı değiştirebilirsiniz.
                  </p>
                  
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-3 mt-6">Tarayıcı Ayarları</h3>
                  <ul className="list-disc list-inside space-y-2">
                    <li><strong>Chrome:</strong> Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler</li>
                    <li><strong>Firefox:</strong> Ayarlar &gt; Gizlilik ve Güvenlik &gt; Çerezler</li>
                    <li><strong>Safari:</strong> Tercihler &gt; Gizlilik &gt; Çerezler</li>
                    <li><strong>Edge:</strong> Ayarlar &gt; Çerezler ve site izinleri</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">6. Çerezleri Reddetmenin Sonuçları</h2>
                  <p>
                    Çerezleri reddederseniz veya silerseniz, web sitesinin bazı özellikleri düzgün çalışmayabilir. 
                    Özellikle:
                  </p>
                  <ul className="list-disc list-inside space-y-2 mt-3">
                    <li>Oturum açma durumunuz hatırlanmayabilir</li>
                    <li>Dil ve bölge tercihleriniz kaybolabilir</li>
                    <li>Site performansı etkilenebilir</li>
                    <li>Kişiselleştirilmiş içerik gösteremeyebiliriz</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-[20px] font-semibold text-[#0e3851] mb-4">7. İletişim</h2>
                  <p>
                    Çerez politikamız hakkında sorularınız varsa, bizimle aşağıdaki kanallardan iletişime geçebilirsiniz:
                  </p>
                  <ul className="list-disc list-inside space-y-2 mt-3">
                    <li>E-posta: info@birsozinsaat.com</li>
                    <li>Telefon: +90 (216) 123 45 67</li>
                    <li>Adres: Ataşehir Bulvarı No: 123, Ataşehir/İstanbul</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl">
                  <p className="text-[14px] text-gray-600">
                    <strong>Son Güncelleme:</strong> 15 Ocak 2024<br />
                    Bu çerez politikası, yasal düzenlemelerdeki değişiklikler ve hizmet güncellemeleri doğrultusunda güncellenebilir.
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
}
